import React from 'react';
import { TableRow } from '@mui/material';
import dateFormatter from '../../utils/dateFormatter';
import { TSTable, TSCell } from '../ui/TableStructure';

const FixturesTable = ({ fixtures, title }) => {
	if (fixtures.length === 0) {
		return <div />;
	}
	const fixturesTable = fixtures.map((fixture) => (
		<TableRow key={fixture.date}>
			<TSCell>{dateFormatter(fixture.date)}</TSCell>
			<TSCell>{fixture.host}</TSCell>
		</TableRow>
	));
	return (
		<TSTable title={title} headings={["Date", "Host"]}>
			{fixturesTable}
		</TSTable>
	);
};

export default FixturesTable;
